import { SYSTEM_ROLE_PERMISSIONS, type SystemRole } from '@repo/contracts';

import { hasAppAccess } from '@/hooks/auth/has-app-access';

/**
 * The held roles that open this app. The server keeps one active role shared
 * by every app, so each app shows only the roles that mean something in it.
 */
export const appRolesOf = (held: readonly SystemRole[]): SystemRole[] =>
  held.filter((role) => hasAppAccess(SYSTEM_ROLE_PERMISSIONS[role]));

/** One app role that is not the active one is still worth offering: it is the way in. */
export const offersRoleSwitch = (
  appRoles: readonly SystemRole[],
  activeRole: SystemRole | null,
): boolean => appRoles.length >= 2 || (appRoles.length === 1 && appRoles[0] !== activeRole);

/** The label under a person's name: the active role only when it belongs to this app. */
export const activeAppRoleOf = (
  held: readonly SystemRole[],
  activeRole: SystemRole | null,
): SystemRole | null => (activeRole && appRolesOf(held).includes(activeRole) ? activeRole : null);
